import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { usePathname } from 'src/routes/hooks';

import { roles } from 'src/utils/roles';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { PageTransition } from 'src/components/animate/page-transition';

import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

// Pages
const UserListPage = lazy(() => import('src/pages/management/users/list'));
const UserViewPage = lazy(() => import('src/pages/management/users/view'));
const UserEditPage = lazy(() => import('src/pages/management/users/edit'));
const UserAddPage = lazy(() => import('src/pages/management/users/add'));

const StoreListPage = lazy(() => import('src/pages/management/stores/list'));
const StoreViewPage = lazy(() => import('src/pages/management/stores/view'));
const StoreEditPage = lazy(() => import('src/pages/management/stores/edit'));
const StoreAddPage = lazy(() => import('src/pages/management/stores/add'));

// Coupon
const CouponListPage = lazy(() => import('src/pages/management/coupon/list'));
// ----------------------------------------------------------------------

const LayoutContent = () => {
  const pathname = usePathname();

  return (
    <DashboardLayout>
      <Suspense fallback={<LoadingScreen />} key={pathname}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </Suspense>
    </DashboardLayout>
  )
};

export const managementRoutes = [
  {
    path: 'management',
    element: CONFIG.auth.skip ? <LayoutContent /> : <AuthGuard><LayoutContent /></AuthGuard>,
    children: [
      {
        roles: [roles.USER_ADMIN],
        path: 'user', children: [
          { element: <RoleBasedGuard roles={[roles.USER_ADMIN]} children={<UserListPage />} />, index: true },
          { path: 'list', element: <RoleBasedGuard roles={[roles.USER_ADMIN]} children={<UserListPage />} /> },
          { path: 'new', element: <RoleBasedGuard roles={[roles.USER_ADMIN]} children={<UserAddPage />} /> },
          { path: ':id/edit', element: <RoleBasedGuard roles={[roles.USER_ADMIN]} children={<UserEditPage />} /> },
          { path: ':id/view', element: <RoleBasedGuard roles={[roles.USER_ADMIN]} children={<UserViewPage />} /> },
        ]
      },
      {
        roles: [roles.STORE_ADMIN],
        path: 'store', children: [
          { element: <RoleBasedGuard roles={[roles.STORE_ADMIN]} children={<StoreListPage />} />, index: true },
          { path: 'list', element: <RoleBasedGuard roles={[roles.STORE_ADMIN]} children={<StoreListPage />} /> },
          { path: 'new', element: <RoleBasedGuard roles={[roles.STORE_ADMIN]} children={<StoreAddPage />} /> },
          { path: ':id/edit', element: <RoleBasedGuard roles={[roles.STORE_ADMIN]} children={<StoreEditPage />} /> },
          { path: ':id/view', element: <RoleBasedGuard roles={[roles.STORE_ADMIN]} children={<StoreViewPage />} /> },
        ]
      },
      {
        roles: [roles.STORE_ADMIN],
        path: 'coupon',
        children: [
          {
            element: <RoleBasedGuard roles={[roles.STORE_ADMIN]} children={<CouponListPage />} />,
            index: true,
          },
        ],
      },
    ],
  },
];
